import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import styles from './Layout.module.css'

export function Topbar() {
  const { profile, signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/gaviota/login')
  }

  return (
    <header className={styles.topbar}>
      <div className={styles.topbarLeft}>
        <span className={styles.workspaceName}>Gaviota Revenue Workspace</span>
      </div>
      <div className={styles.topbarRight}>
        {profile?.role === 'keder_admin' && (
          <a href="/admin" className={styles.adminLink}>Admin</a>
        )}
        <button onClick={handleSignOut} className={styles.signOutBtn}>
          Sign out
        </button>
      </div>
    </header>
  )
}
